import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function indexSlaughterSchedule(payload) {
  const { groupId, farmId, page, sorter, filters, size, signal } = payload;
  let sortS = "";
  if (sorter && Object.entries(sorter).length > 0) {
    const { field, order } = sorter;
    const orderS = order && order === "descend" ? "DESC" : "ASC";
    sortS = `&sort=${field}&direction=${orderS}`;
  }
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/slaughter-schedules?${
      page ? `&page=${page - 1}` : ""
    }${size ? `&size=${size}` : ""}${sortS}${
      filters !== "" && filters ? `&search=${filters}` : ""
    }`,
    getHeaders(false, signal),
  );
}
